import { render, staticRenderFns } from "./messageContent.vue?vue&type=template&id=2460a314&"
import script from "./messageContent.vue?vue&type=script&lang=js&"
export * from "./messageContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports